import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ChartRow, formatCount, formatPct } from "./types";

interface DimensionTableProps {
	rows: ChartRow[];
	dimensionLabel: string;
}

const cellSx = { py: 0.75, px: 1, fontSize: "0.8125rem" };

const DimensionTable: React.FC<DimensionTableProps> = ({ rows, dimensionLabel }) => {
	const { t, i18n } = useTranslation();

	return (
		<TableContainer sx={{ overflowX: "auto", border: "none", borderRadius: 0 }}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell sx={cellSx}>{dimensionLabel}</TableCell>
						<TableCell align="right" sx={cellSx}>
							{t("communityDashboard.table.talents")}
						</TableCell>
						<TableCell align="right" sx={cellSx}>
							{t("communityDashboard.table.pctOfTalents")}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.length === 0 ? (
						<TableRow>
							<TableCell colSpan={3} align="center" sx={cellSx}>
								{t("communityDashboard.empty")}
							</TableCell>
						</TableRow>
					) : (
						rows.map(row => (
							<TableRow key={row.id}>
								<TableCell sx={cellSx}>{row.label}</TableCell>
								<TableCell align="right" sx={{ ...cellSx, fontWeight: 700 }}>
									{formatCount(row.count, i18n.language)}
								</TableCell>
								<TableCell align="right" sx={cellSx}>
									{formatPct(row.pct, i18n.language)}
								</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default DimensionTable;
